window.tagalysDisableLegacyScript = true;
// TODO: remove — debugging Judge.me metafields on Tagalys products
console.log("[tagalys debug] theme-tagalys.js loaded (metafields debug build)");

export const tagalys = {
  tagalysConfiguration: {
    api: {
      serverUrl: "https://api-r3.tagalys.com",
      credentials: {
        clientCode: "6367A5F03EB23BD1",
        apiKey: "fbfd378e440babdb7dcfde08db8da421",
      },
      storeId: "83175735603",
    },
    currency: {
      code: "USD",
      label: "$",
      fractionalDigits: 2,
    },
    analyticsStorageConsentProvided: function () {
      return true;
    },
    track: true,
  },
  platformConfiguration: {
    platform: "Shopify",
    countryCode: "US",
    baseCountryCode: "US",
    useStorefrontAPIForSecondaryMarkets: true,
    waitForStorefrontAPI: true,
    storefrontAPI: {
      accessToken: "b898a7a63b615350f86e002ee30e25dc",
      myShopifyDomain: "seattlecoffeegear.myshopify.com",
    },
    metafields: {
      products: [
        { 
          namespace: "reviews",
          key: "rating"
        },
        { 
          namespace: "reviews",
          key: "rating_count"
        }
      ],
      collections: [],
      pages: [],
      articles: [],
    },
  },

  TagalysCustomisations: {},

  /**
   * Reads the standard reviews.rating / reviews.rating_count metafields off a
   * Tagalys product. Tagalys exposes them as metafields[namespace][key] =
   * { type, value }, where a `rating` value is the raw Storefront JSON string
   * ({"scale_min":"1.0","scale_max":"5.0","value":"4.8"}). Returns
   * { value, count } with value rounded to one decimal, or null if unrated.
   */
  tagalysRating(item) {
    const reviews = item?.metafields?.reviews;
    if (!reviews?.rating) return null;

    let rating = reviews.rating.value;
    if (typeof rating === "string") {
      try {
        rating = JSON.parse(rating);
      } catch (e) {
        // plain numeric string
      }
    }
    const value = parseFloat(rating?.value ?? rating);
    if (!value) return null;

    const count = parseInt(reviews.rating_count?.value, 10) || 0;
    return { value: Math.round(value * 10) / 10, count };
  },

  setTagalysConfiguration() {
    const Tagalys = window.Tagalys;
    Tagalys.setConfiguration(tagalys.tagalysConfiguration);
  },

  setPlatformConfiguration() {
    const Tagalys = window.Tagalys;
    Tagalys.setPlatformConfiguration(tagalys.platformConfiguration);
  },

  initSearchSuggestions() {
    const Tagalys = window.Tagalys;
    window.searchSuggestions = Tagalys.APIConnector.SearchSuggestions.new({
      params: {
        request: {
          collections: { limit: 2 },
          products: { limit: 4 },
          // Headroom over the 2 of each we display. When Tagalys merges pages
          // and articles into one section these limits act as a shared pool, so
          // asking for only what we show lets one kind crowd out the other.
          // Pages gets extra room because /pages/shop-* results are filtered
          // out below, and there are 100+ of them.
          pages: { limit: 30 },
          articles: { limit: 8 },
          queries: { limit: 4 },
        },
      },
      onSuccess: (response, helpers) => {
        this.search_loading = true;

        const sections = response.queries || [];
        const sectionItems = (id) =>
          sections.filter((section) => section.section_id === id)[0]?.items || [];

        let products = response.products;
        let collections = sectionItems("collections");

        // Tagalys has returned this content two different ways: everything merged
        // into a single "pages" section, and pages/articles split into their own
        // sections. Read both and classify by URL so either shape works — with
        // only the merged read, a split response shows no articles at all.
        let content = sectionItems("pages")
          .concat(sectionItems("articles"))
          .filter((item, i, all) => all.findIndex((other) => other.link === item.link) === i);

        let articles = content.filter((item) => (item.link || "").includes("/blogs/")).slice(0, 2);
        // /pages/shop-* pages are never offered as page suggestions.
        let pages = content
          .filter((item) => (item.link || "").includes("/pages/"))
          .filter((item) => !/\/pages\/shop-/i.test(item.link))
          .slice(0, 2);

        this.search_items = products ? products : [];
        this.search_items_collections = collections;
        this.search_items_pages = pages;
        this.search_items_articles = articles;

        this.search_loading = false;
      },
      onFailure: (response, helpers) => {
        // intentionally empty
      },
    });
  },

  updateSearchSuggestions(event) {
    if (event.target) {
      const searchTerm = event.target.value;

      this.search_loading = true;
      if (searchTerm.length === 0 || !searchTerm.replace(/\s/g, "").length) {
        this.search_loading = false;
        this.search_items = [];
        this.search_items_collections = [];
        this.search_items_pages = [];
        this.search_items_articles = [];
        this.search_items_queries = [];
        return;
      }

      window.searchSuggestions.helpers.updateQuery(searchTerm);
    }
  },

  renderFocusSuggestions(event) {
    if (event.target) {
      const typedQuery = event.target.value;
      if (typedQuery == "") {
        window.searchSuggestions.helpers.getRecentAndPopularSearches(5, 10).then((response) => {
          if (response.popularSearches.length == 0 && response.recentSearches.length == 0) {
            this.search_items_suggestions = [];
            this.search_items_recent = [];
          }

          this.search_items_suggestions = response.popularSearches;
          this.search_items_recent = response.recentSearches;
        });
      }
    }
  },

  removeRecentSearch(queryString) {
    window.searchSuggestions.helpers.removeRecentSearch(queryString);
  },

  initSearchResults(query) {
    const Tagalys = window.Tagalys;

    window.searchResultsInstance = Tagalys.APIConnector.SearchResults.new({
      params: {
        query: query,
        perPage: 12,
      },
      onSuccess: (response, helpers) => {
        if (response.error == "Empty Query") {
          this.search_results_filters = [];
          this.search_results_page = 0;
          this.search_results_pages_total = 0;
          this.search_results_products = [];
          this.search_results_products_total = 0;
          this.search_results_query_mode = "";
          this.search_results_query = "";
          this.search_results_query_original = "";
          this.search_results_sort_options = [];
          return;
        }
        if (response.redirect_to_url) {
          window.location.assign(response.redirect_to_url);
          return;
        }

        const data = response;
        // TODO: remove — debugging Judge.me metafields on Tagalys products
        console.log("[tagalys debug] first product keys:", Object.keys(data.products?.[0] || {}).join(", "));
        console.log("[tagalys debug] first product test metafields:", JSON.stringify(data.products?.[0]?.metafields, null, 2));
        console.log("[tagalys debug] first product:", JSON.stringify(data.products?.[0], null, 2));
        if (helpers.isValidQuery()) {
          if (data.products.length > 0) {
            let filters = data.filters,
              page = data.page,
              products = data.products,
              query_mode = data.query_mode,
              query = data.query,
              sort_options = data.sort_options,
              total = data.total,
              total_pages = data.total_pages;

            this.search_results_filters = filters;
            this.search_results_page = page;
            this.search_results_pages_total = total_pages;
            this.search_results_products = products;
            this.search_results_products_total = total;
            this.search_results_query_mode = query_mode;
            this.search_results_query = query;
            this.search_results_query_original = "";
            this.search_results_sort_options = sort_options;

            window.searchSuggestions.helpers.recordRecentSearch(`?q=${query}`);
          } else {
            this.search_results_filters = [];
            this.search_results_page = 0;
            this.search_results_pages_total = 0;
            this.search_results_products = [];
            this.search_results_products_total = 0;
            this.search_results_query_mode = "";
            this.search_results_query = "";
            this.search_results_query_original = "";
            this.search_results_sort_options = [];
          }
        } else {
          if (helpers.isSpellingCorrectedQuery()) {
            let filters = data.filters,
              page = data.page,
              products = data.products,
              query_mode = data.query_mode,
              query = data.query,
              query_original = data.query_original,
              sort_options = data.sort_options,
              total = data.total,
              total_pages = data.total_pages;

            this.search_results_filters = filters;
            this.search_results_page = page;
            this.search_results_pages_total = total_pages;
            this.search_results_products = products;
            this.search_results_products_total = total;
            this.search_results_query_mode = query_mode;
            this.search_results_query = query;
            this.search_results_query_original = query_original;
            this.search_results_sort_options = sort_options;
          } else {
            let filters = data.filters,
              page = data.page,
              products = data.products,
              query_mode = data.query_mode,
              query = data.query,
              query_original = data.query_original,
              sort_options = data.sort_options,
              total = data.total,
              total_pages = data.total_pages;

            this.search_results_filters = filters;
            this.search_results_page = page;
            this.search_results_pages_total = total_pages;
            this.search_results_products = products;
            this.search_results_products_total = total;
            this.search_results_query_mode = query_mode;
            this.search_results_query = query;
            this.search_results_query_original = query_original;
            this.search_results_sort_options = sort_options;
          }
        }
      },
    });
    window.searchResultsInstance.helpers.call();
  },

  initSearchRecommendations() {
    const Tagalys = window.Tagalys;

    window.searchRecommendationInstance = Tagalys.APIConnector.SmartWidget.call({
      params: {
        widgetId: "632333268cc97dca028c",
        limit: 12,
      },
      onSuccess: (response) => {
        this.search_recommended_products = [];
        this.search_recommended_products_total = 0;

        const recData = response;
        if (recData.products.length > 0) {
          let products = recData.products,
            total = recData.products.length;
          this.search_recommended_products = products;
          this.search_recommended_products_total = total;
        }
      },
      onFailure: (response) => {
        // intentionally empty
      },
    });
  },

  initTagalys(callback = () => {}) {
    if (window.Tagalys) {
      tagalys.setTagalysConfiguration();
      tagalys.setPlatformConfiguration();
      callback();
    } else {
      window.addEventListener("DOMContentLoaded", function () {
        tagalys.setTagalysConfiguration();
        tagalys.setPlatformConfiguration();
        callback();
      });
    }
  },
};
